import React, { useState, useEffect, useCallback } from 'react';

import { downloadFile, extractFileNameFromHeaders } from '../../../../util/DownloadUtil';

import { retrieveQueryPerTypeReport, downloadQueryPerTypeReport } from '../../../../services/ReportService';

import { SaveButton } from '../../../common/button/save-button/SaveButton';
import { Table } from '../../../common/table/Table';

import './QueriesPerType.css';

export const QueriesPerType = ({
  facility,
  dates,
  resetFilters,
  context,
  setSpinnerText,
  showToaster,
  downloadEnabled,
}) => {
  const [heading, setHeading] = useState('');
  const [results, setResults] = useState([]);

  const generateReport = useCallback(async () => {
    setSpinnerText('Generating Report');
    const [data, error] = await retrieveQueryPerTypeReport(context.username, {
      facilityExternalReference: facility.externalReference,
      dates,
    });
    if (data) {
      if (data.responseStatus === 'Success') {
        setHeading(data.heading);
        setResults(
          data.queryPerTypeVOS.map((vo) => {
            const { queryType, grandTotal, queryPerStudyVOS } = vo;

            const result = {
              queryType,
            };

            queryPerStudyVOS.forEach((vo) => {
              result[vo.studyName] = vo.total;
            });

            result.grandTotal = grandTotal;

            return result;
          })
        );
      } else {
        showToaster(data);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(undefined);
  }, [context, setSpinnerText, showToaster, facility, dates]);

  useEffect(() => {
    generateReport();
  }, [generateReport]);

  const handleDownloadExcelClick = async () => {
    setSpinnerText('Downloading Queries per Type Report');
    const [data, headers, error] = await downloadQueryPerTypeReport(context.username, {
      facilityExternalReference: facility.externalReference,
      dates,
    });
    if (data) {
      const name = extractFileNameFromHeaders(headers);
      downloadFile(data, name);
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(undefined);
  };

  return (
    <section className="queries-per-type-content">
      <div className="queries-per-type-table">
        <h1 className="queries-per-type-table-heading">{heading}</h1>
        <Table
          tableData={results}
          tableTitle="Queries per Type"
          maxRowCount={7}
          hiddenColumns={[]}
          columnWidths={{ queryType: '350px' }}
          searchEnabled
          filterEnabled
          horizontalScroll
          stickyFirstRow
        />
      </div>
      <div className="queries-per-type-table-buttons">
        <SaveButton
          title="Reset Filters"
          onClick={resetFilters}
          color="white"
          textColor="#077187"
          border="1px solid #077187"
        />
        {downloadEnabled && (
          <SaveButton
            title="Download Excel"
            onClick={handleDownloadExcelClick}
            color="#077187"
            border="1px solid #077187"
          />
        )}
      </div>
    </section>
  );
};
